import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-international-invoice',
  templateUrl: './international-invoice.component.html',
  styleUrls: ['./international-invoice.component.scss']
})
export class InternationalInvoiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
